<template>
  <div>
    <h3>Facebook</h3>
    <!--
    <button v-on:click="reverseMessage">Reverse Message</button>
    <br />
    -->
    <div class="ui stackable three column grid">
      <div class="fb-page" v-bind:data-href="channel.url" data-tabs="timeline" data-small-header="true" data-adapt-container-width="false" data-hide-cover="false" data-show-facepile="false" v-for="channel in channels"></div>
    </div>
    <div class="ui stackable two column grid">
      <div v-for="facebook in facebooks">
        <div class="column fb-post" v-bind:data-href="facebook.url" data-show-text="true"></div>
        <div class="fb-comments" v-bind:data-href="facebook.url" data-numposts="5"></div>
      </div>
    </div>
    <!--
    <div class="fb-post" data-href="https://www.facebook.com/brightside/posts/1219086204886787" data-width="350" data-show-text="true">
      <blockquote cite="https://www.facebook.com/brightside/posts/1219086204886787" class="fb-xfbml-parse-ignore">
        <p>I want to own all of them! Especially number 2.&#x1f60d;</p>
        <a href="https://www.facebook.com/brightside/">Bright Side</a>에 의해 게시 됨&nbsp;
        <a href="https://www.facebook.com/brightside/posts/1219086204886787">2017년 3월 10일 금요일</a>
      </blockquote>
    </div>

    <div class="fb-post" data-href="https://www.facebook.com/TheEpisodeApp/videos/679893675541296/" data-width="350" data-show-text="true">  <blockquote cite="https://www.facebook.com/TheEpisodeApp/videos/679893675541296/" class="fb-xfbml-parse-ignore">    <p>Choose how YOUR story ends on the #1 interactive, story-telling app!</p>    <a href="https://www.facebook.com/TheEpisodeApp/">Episode</a>에 의해 게시 됨&nbsp;
        <a href="https://www.facebook.com/TheEpisodeApp/videos/679893675541296/">2017년 3월 3일 금요일</a>
      </blockquote>
    </div>
    -->
  </div>
</template>
<script>
  export default {
    name: 'facebook',
    data() {
      return {
        facebooks: [{
          url: 'https://www.facebook.com/brightside/posts/1219086204886787'
        }, {
          url: 'https://www.facebook.com/cubebrush/videos/989872117781050/'
        }, {
          url: 'https://www.facebook.com/TheEpisodeApp/videos/679893675541296/'
        }],
        channels: [{
          url: 'https://www.facebook.com/brightside'
        }, {
          url: 'https://www.facebook.com/cubebrush'
        }, {
          url: 'https://www.facebook.com/TheEpisodeApp'
        }]
      }
    },
    methods: {
      reverseMessage() {
        window.FB.XFBML.parse()
      }
    },
    mounted() {
      // window.console.log(this.$root.$firebaseRefs.anArray.limitToLast(25))
      // window.console.log(this.$root.$firebaseRefs.anArray.limitToLast(25))

      this.$root.$firebaseRefs.anObject.once('value', function(snapshot) {
        window.console.log(snapshot.val())
        window.FB.XFBML.parse()
      })
    },
    beforeRouteUpdate(to, from, next) {
      // window.FB.XFBML.parse()
      // window.console.log('beforeRouteUpdate');
      // (function(d, s, id) {
      //   // var js, fjs = d.getElementsByTagName(s)[0]
      //   var fjs = d.getElementsByTagName(s)[0]
      //   if (d.getElementById(id)) return
      //   var js = d.createElement(s); js.id = id
      //   js.src = '//connect.facebook.net/ko_KR/sdk.js#xfbml=1&version=v2.8&appId=719700301513151'
      //   fjs.parentNode.insertBefore(js, fjs)
      // }(document, 'script', 'facebook-jssdk'))
    }
  }
</script>



// WEBPACK FOOTER //
// Facebook.vue?7849c1d8